// @flow
import { createListenerMiddleware } from '@reduxjs/toolkit';
import appInterface from '../helpers/appInterface';

const appInterfaceMiddleware = createListenerMiddleware();

const actionMap = [
  ['VEHICLE_ADDED', 'vehicle/CREATE_VEHICLE_SUCCESS'],
  ['VEHICLE_DELETED', 'vehicle/deleteUserVehicle/fulfilled'],
  ['PAYMENT_METHOD_ADDED', 'payments/createPaymentMethod/fulfilled'],
  ['PAYMENT_METHOD_DELETED', 'payments/deletePaymentMethod/fulfilled'],
  ['CHANGE_EMAIL', 'profile/submitEmail/fulfilled'],
  ['CHANGE_DETAILS', 'profile/submitDetails/fulfilled'],
  ['PASSWORD_RESET_REQUEST', 'profile/sendResetPasswordLink/fulfilled'],
  ['CHANGE_ADDRESS', 'profile/SUBMIT_ADDRESS_SUCCESS']
];
actionMap.forEach(([value, type]) =>
  appInterfaceMiddleware.startListening({
    type,
    effect: () => {
      appInterface.updateProfile(value);
    }
  })
);

export default appInterfaceMiddleware;
